<!-- 下载地址 -->
<template>
	<div id="app">
		<div v-if="showWechatTip" class="bg">
			<img src="images/live_weixin.png" alt="请在浏览器中打开" />
		</div>
		<div v-else>
			<p style="text-align: center; margin-top: 50px;">正在检测设备并跳转...</p>
		</div>
	</div>
</template>

<script>
	// 将原始的浏览器检测逻辑封装为一个方法
	const browser = {
		versions: (function() {
			const u = navigator.userAgent;
			// const app = navigator.appVersion; // 原始代码未使用app，可省略
			return {
				// 移动终端浏览器版本信息
				mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), // 是否为移动终端
				ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
				android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // android终端或者uc浏览器
				iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, // 是否为iPhone或者QQHD浏览器
				iPad: u.indexOf('iPad') > -1, // 是否iPad
			};
		})(),
	};

	export default {
		name: 'AppRedirect',
		data() {
			return {
				// 用于控制是否显示“请在浏览器中打开”的提示图片
				showWechatTip: false,
			};
		},
		// 在组件挂载后执行逻辑，相当于原始代码中的 <script> 块
		mounted() {
			this.handleRedirect();
		},
		methods: {
			handleRedirect() {
				// 获取用户代理信息并转换为小写
				const ua = window.navigator.userAgent.toLowerCase();

				// 1. iOS 设备重定向
				if (browser.versions.ios || browser.versions.iPhone || browser.versions.iPad) {
					// iOS 跳转链接
					window.location.href = "https://itunes.apple.com/cn/app/qiui%E5%9B%9A%E7%88%B1/id1460438419?mt=8";
				}
				// 2. Android 设备处理
				else if (browser.versions.android) {
					// 检查是否在微信或QQ内置浏览器中
					const isWechat = ua.includes('micromessenger'); // || ua.match(/MicroMessenger/i) == 'micromessenger'
					const isQQ = ua.includes('_sq_'); // || ua.match(/_SQ_/i) == '_sq_'

					if (isWechat || isQQ) {
						// 如果是微信或QQ，显示提示图片
						this.showWechatTip = true;
						// 注意：在 Vue 中，我们通过修改 data 属性来控制元素的显示（v-if），而不是直接操作 DOM (如: $(".bg").show();)
					} else {
						// 否则直接重定向到 APK 下载链接
						window.location.href = "https://accelerate.qiuitoy.com/apk/qiui.apk";
					}
				}
				// 3. 其他非移动设备（可选：可以添加桌面版提示或默认行为）
				else {
					console.log("非移动设备或未识别设备，未执行重定向。");
				}
			}
		}
	};
</script>

<style scoped>
	/* 原始代码中的样式 */
	body {
		background: rgba(0, 0, 0, 0.3);
		padding: 0;
		margin: 0;
	}

	img {
		width: 100%;
	}
</style>